import { DOMAIN } from './RequestConversation.constants';
import get from 'lodash/get';

export const getStore = state => get(state, DOMAIN) || {};

export const getMessages = state => getStore(state).messages || [];
export const getError = state => getStore(state).error;
export const isLoading = state => getStore(state).loading;
export const isSending = state => getStore(state).sending;
